import { render, staticRenderFns } from "./PredefinedScriptCrud.vue?vue&type=template&id=3a8e0b78"
import script from "./PredefinedScriptCrud.vue?vue&type=script&lang=js"
export * from "./PredefinedScriptCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports